import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService } from '../shared/authentication.service';
import { CredentialService } from '../credentials/credential.service';
import { ProviderService } from './provider.service';
import { GenderService } from '../genders/gender.service';
import { StateService } from '../states/state.service';
import { parseErrors } from '../shared/api.service';
import { Credential } from '../credentials/credential';

@Component({
  selector: 'personal-profile',
  templateUrl: 'personal-profile.component.html',
  styleUrls: ['./personal-profile.component.scss']
})

export class PersonalProfileComponent implements OnInit {
  model: any = {
    credentials: [],
    gender: null
  };
  loading = false;
  errors = [];
  search = '';
  user;
  providerReq;
  credentialsReq;
  credentials = [];
  gendersReq;
  genders = [];
  statesReq;
  states = [];
  compCredentials = (val1: string, val2: Credential) => val1 === val2.id;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private providerService: ProviderService,
    private authenticationService: AuthenticationService,
    private credentialService: CredentialService,
    private genderService: GenderService,
    private stateService: StateService
  ) { }

  ngOnInit() {
    this.user = this.authenticationService.user();
    this.getProvider();
    this.getCredentials();
    this.getGenders();
    this.getStates();
  }

  submit() {
    this.loading = true;
    this.errors = [];
    if (this.user) { this.model.user = this.user.id; }
    this.providerService.save(this.model).subscribe(provider => {
      this.loading = false;
      this.router.navigate(['/profile/personal']);
    }, err => {
      this.loading = false;
      this.errors = err;
    });
  }

  getProvider() {
    if (this.providerReq) { this.providerReq.unsubscribe(); }
    this.providerReq = this.providerService.getProvider(
      this.user && this.user.provider && this.user.provider.id
    ).subscribe(provider => {
      this.model = provider;
      this.model.credentials = provider.credentials;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  getCredentials(query: any = {}) {
    if (this.credentialsReq) { this.credentialsReq.unsubscribe(); }
    this.credentialsReq = this.credentialService.getCredentials({
      search: this.search,
      ...query
    }).subscribe(credentials => {
      this.credentials = credentials;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  getGenders(query: any = {}) {
    if (this.gendersReq) { this.gendersReq.unsubscribe(); }
    this.gendersReq = this.genderService.getGenders({
      search: this.search,
      ...query
    }).subscribe(genders => {
      this.genders = genders;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  getStates(query: any = {}) {
    if (this.statesReq) { this.statesReq.unsubscribe(); }
    this.statesReq = this.stateService.getStates({
      search: this.search,
      ...query
    }).subscribe(states => {
      this.states = states;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  selectOption(element, type) {
    switch (type) {
      case 'gender':
        this.model[type] = element;
        break;
      case 'mailingState':
        this.model[type] = element;
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/personal-profile.component.ts